/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnchorageCallsGet200ResponseRecordsInner } from './AnchorageCallsGet200ResponseRecordsInner';
import {
    AnchorageCallsGet200ResponseRecordsInnerFromJSON,
    AnchorageCallsGet200ResponseRecordsInnerFromJSONTyped,
    AnchorageCallsGet200ResponseRecordsInnerToJSON,
} from './AnchorageCallsGet200ResponseRecordsInner';

/**
 * 
 * @export
 * @interface AnchorageCallsGet200Response
 */
export interface AnchorageCallsGet200Response {
    /**
     * List of anchorage calls. The information contains the label of the anchorage area and the ship/vessel information and ATA and ATD (if the vessel has left) and the locode(s) of any associated port(s)
     * @type {Array<AnchorageCallsGet200ResponseRecordsInner>}
     * @memberof AnchorageCallsGet200Response
     */
    records?: Array<AnchorageCallsGet200ResponseRecordsInner>;
}

/**
 * Check if a given object implements the AnchorageCallsGet200Response interface.
 */
export function instanceOfAnchorageCallsGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnchorageCallsGet200ResponseFromJSON(json: any): AnchorageCallsGet200Response {
    return AnchorageCallsGet200ResponseFromJSONTyped(json, false);
}

export function AnchorageCallsGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnchorageCallsGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(AnchorageCallsGet200ResponseRecordsInnerFromJSON)),
    };
}

export function AnchorageCallsGet200ResponseToJSON(value?: AnchorageCallsGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(AnchorageCallsGet200ResponseRecordsInnerToJSON)),
    };
}

